// Single frontend resolver for customer credit modes. Stored vocabulary stays `open` | `limit`
// (customers) and `none` | `open` | `limit` (business default); screens only ever show these labels.
export const CREDIT_MODE_LABELS = { none: "No Credit", open_account: "Open Account", credit_limit: "Credit Limit" };
export const STORED_FROM_CANONICAL = { none: "none", open_account: "open", credit_limit: "limit" };
const CANONICAL_FROM_STORED = { none: "none", open: "open_account", limit: "credit_limit", open_account: "open_account", credit_limit: "credit_limit" };

// Mirrors backend effective_credit_mode: credit off -> none; stored open -> open_account; limit / null / legacy -> credit_limit.
export function effectiveCreditMode(c) {
  if (!c) return "none";
  if (c.effective_credit_mode) return c.effective_credit_mode;
  if (c.credit_enabled === false) return "none";
  return c.credit_mode === "open" ? "open_account" : "credit_limit";
}

export const creditModeLabel = (c) => CREDIT_MODE_LABELS[effectiveCreditMode(c)];
export const isOpenAccount = (c) => effectiveCreditMode(c) === "open_account";
export const enforcesLimit = (c) => effectiveCreditMode(c) === "credit_limit";

// Tenant default as canonical; missing/unknown resolves to credit_limit (backend setdefault is "limit").
export const businessDefaultMode = (business) => CANONICAL_FROM_STORED[business?.default_credit_mode] || "credit_limit";

// Stored `credit_mode` to preload into a new-customer form when credit gets enabled (a No Credit default falls back to limit).
export const defaultStoredModeForForm = (business) => {
  const d = businessDefaultMode(business);
  return d === "none" ? "limit" : STORED_FROM_CANONICAL[d];
};

// Stored `credit_mode` to preload into an edit form so a legacy/null mode is shown exactly as the backend enforces it.
export const storedModeForEdit = (c, business) => (c?.credit_enabled ? STORED_FROM_CANONICAL[effectiveCreditMode(c)] : defaultStoredModeForForm(business));

// Display-only account health for Open Account customers: Hold / Closed (account_status) > Overdue (aging) > Good.
export function accountStatusView(c) {
  if (c?.account_status === "closed") return { label: "Closed", accent: "text-rose-500" };
  if (c?.account_status === "hold") return { label: "On Hold", accent: "text-amber-600" };
  if ((c?.max_days_overdue || 0) > 0) return { label: `Overdue · ${c.max_days_overdue} days`, accent: "text-rose-500" };
  return { label: "Good", accent: "text-emerald-500" };
}
